import type {
	SelectOption,
	DefaultOrganizationData,
} from '@atlassian/jira-issue-field-organizations/src/common/types.tsx';
import type { FieldValue, JiraOrganizationsFieldInput } from './types.tsx';

export const mapDataToOrganizationOptions = (data: DefaultOrganizationData[]): FieldValue =>
	data.map(
		({ organizationName, organizationId }): SelectOption => ({
			value: organizationId,
			label: organizationName,
		}),
	);

export const mutateOrganizationsField = (
	selectedOrganizations: FieldValue,
	fieldId: string,
): JiraOrganizationsFieldInput => ({
	organizationField: {
		fieldId,
		organizations: selectedOrganizations.map(({ value }) => ({ organizationId: value })),
	},
});
